import React from "react";
import { getString } from "../../utilities";

export default function PlanButton({ plan, pRole, color, func }) {
  const planButtonSyle = (plan, pRole, color) => {
    const active = plan === pRole ? " active" : "";
    return `outlined button-flat-color round ${color}${active}`;
  };

  return (
    <button
      type="button"
      className={planButtonSyle(plan.toLowerCase(), pRole.toLowerCase(), color)}
      onClick={() => {
        if (plan.toLowerCase() !== pRole.toLowerCase()) {
          func(pRole);
        }
      }}
    >
      {getString(`subscribe.plans.${pRole.toLowerCase()}.title.0`)}
    </button>
  );
}
